/**
 * @file index.tsx
 * @module app/modules/outstanding-report/index
 * @description Implements the index workflow for outstanding-report management.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { lazy } from "react";
import { PageLink, PageTitle } from "../../../_admin/layout/core";
import OutstandingReportComponent from "./outstanding-report";

const outstandingReportBreadcrumbs: Array<PageLink> = [
  {
    title: "Outstanding Reports",
    path: "/outstanding-report",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const index = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route path="*" element={<Navigate to="/error/404" />} />
        <Route
          index
          element={
            <>
              <PageTitle>
                Outstanding Reports
              </PageTitle>
              <OutstandingReportComponent />
            </>
          }
        />
      </Route>
    </Routes>
  );
};
export default index;
